import { render, staticRenderFns } from "./HotTopicPage.vue?vue&type=template&id=5eab2f39"
import script from "./HotTopicPage.vue?vue&type=script&lang=ts"
export * from "./HotTopicPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports